module.exports = __webpack_public_path__ + "static/img/9.ac11f9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lhzb/9.png
// module id = LsZO
// module chunks = 0